export default function addDocument(collection, data) {
	return collection.add(data);
}
